// repos
export const SET_GOT_REPOS = 'SET_GOT_REPOS'
export const RECEIVE_REPOS = 'RECEIVE_REPOS'
export const SET_CURRENT_REPO = 'SET_CURRENT_REPO'
export const SET_FIRST_REPO_CURRENT = 'SET_FIRST_REPO_CURRENT'
export const SET_GETTING_SYNC_TIME = 'SET_GETTING_SYNC_TIME'
export const RECEIVE_SYNC_TIME = 'RECEIVE_SYNC_TIME'
export const RECEIVE_REPO_SOURCES = 'RECEIVE_REPO_SOURCES'
export const SET_CURRENT_SOURCE = 'SET_CURRENT_SOURCE'
export const SET_GETTING_REPO_SYSTEM_DEPENDENCIES = 'SET_GETTING_REPO_SYSTEM_DEPENDENCIES'
export const RECEIVE_REPO_SYSTEM_DEPENDENCIES = 'RECEIVE_REPO_SYSTEM_DEPENDENCIES'
export const RECEIVE_URL_INFO = 'RECEIVE_URL_INFO'
export const SET_GETTING_URL = 'SET_GETTING_URL'
export const SET_GETTING_DECODED_URL = 'SET_GETTING_DECODED_URL'
export const RECEIVE_DECODED_URL_INFO = 'RECEIVE_DECODED_URL_INFO'

// alerts
export const SET_ALERTS = 'SET_ALERTS'

// status
export const RECEIVE_STATUS = 'RECEIVE_STATUS'
export const SET_GETTING_METRICS_STATUS = 'SET_GETTING_METRICS_STATUS'
export const RECEIVE_METRICS_STATUS = 'RECEIVE_METRICS_STATUS'
export const SET_GETTING_VERSION = 'SET_GETTING_VERSION'
export const RECEIVE_VERSION = 'RECEIVE_VERSION'
export const SET_LATEST_VERSION_UPDATE_SEEN = 'SET_LATEST_VERSION_UPDATE_SEEN'
export const SET_LATEST_VERSION_UPDATE = 'SET_LATEST_VERSION_UPDATE'
export const SHOW_LATEST_UPDATE = 'SHOW_LATEST_UPDATE'
export const SET_GETTING_CUSTOM_PAGE = 'SET_GETTING_CUSTOM_PAGE'
export const RECEIVE_CUSTOM_PAGE = 'RECEIVE_CUSTOM_PAGE'

// packages
export const SET_GETTING_PACKAGE_DETAILS = 'SET_GETTING_PACKAGE_DETAILS'
export const RECEIVE_PACKAGE_DETAILS = 'RECEIVE_PACKAGE_DETAILS'
export const SET_NO_SUBSCRIPTIONS_FOR_REPO = 'SET_NO_SUBSCRIPTIONS_FOR_REPO'
export const SET_GETTING_PACKAGES = 'SET_GETTING_PACKAGES'
export const SET_GETTING_PACKAGES_GUID = 'SET_GETTING_PACKAGES_GUID'
export const CLEAR_PACKAGES = 'CLEAR_PACKAGES'
export const RECEIVE_FIRST_PACKAGES = 'RECEIVE_FIRST_PACKAGES'
export const RECEIVE_NEXT_PACKAGES = 'RECEIVE_NEXT_PACKAGES'
export const SET_SELECTED_PACKAGE = 'SET_SELECTED_PACKAGE'
export const SET_SELECTED_ARCHIVE = 'SET_SELECTED_ARCHIVE'
export const SET_SELECTED_PACKAGE_VERSION = 'SET_SELECTED_PACKAGE_VERSION'
export const SET_SELECTED_PACKAGE_RELEASE_DISTRIBUTIONS = 'SET_SELECTED_PACKAGE_RELEASE_DISTRIBUTIONS'
export const RECEIVE_PACKAGE_VERSIONS = 'RECEIVE_PACKAGE_VERSIONS'
export const RECEIVE_PACKAGE_README = 'RECEIVE_PACKAGE_README'
export const SET_SELECTED_OS = 'SET_SELECTED_OS'
export const SET_SELECTED_BIOC_VERSION = 'SET_SELECTED_BIOC_VERSION'
export const SET_GETTING_SYSTEM_DEPENDENCIES = 'SET_GETTING_SYSTEM_DEPENDENCIES'
export const RECEIVE_PACKAGE_SYSTEM_DEPENDENCIES = 'RECEIVE_PACKAGE_SYSTEM_DEPENDENCIES'
export const VERIFY_SELECTED_OS = 'VERIFY_SELECTED_OS'
export const VERIFY_SELECTED_BIOC_VERSION = 'VERIFY_SELECTED_BIOC_VERSION'

// transactions
export const SET_GETTING_TRANSACTIONS = 'SET_GETTING_TRANSACTIONS'
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS'
export const RECEIVE_FIRST_TRANSACTIONS = 'RECEIVE_FIRST_TRANSACTIONS'
export const RECEIVE_NEXT_TRANSACTIONS = 'RECEIVE_NEXT_TRANSACTIONS'
export const RECEIVE_TRANSACTION_DETAILS = 'RECEIVE_TRANSACTION_DETAILS'
export const SET_GETTING_TRANSACTION_DETAILS = 'SET_GETTING_TRANSACTION_DETAILS'
export const CLEAR_GETTING_TRANSACTION_DETAILS = 'CLEAR_GETTING_TRANSACTION_DETAILS'

export const SET_GETTING_TRANSACTION_PACKAGES = 'SET_GETTING_TRANSACTION_PACKAGES'
export const CLEAR_GETTING_TRANSACTION_PACKAGES = 'CLEAR_GETTING_TRANSACTION_PACKAGES'
export const RECEIVE_FIRST_TRANSACTION_PACKAGES = 'RECEIVE_FIRST_TRANSACTION_PACKAGES'
export const RECEIVE_NEXT_TRANSACTION_PACKAGES = 'RECEIVE_NEXT_TRANSACTION_PACKAGES'

export const SET_GETTING_TRANSACTION_DATES = 'SET_GETTING_TRANSACTION_DATES'
export const CLEAR_TRANSACTION_DATES = 'CLEAR_TRANSACTION_DATES'
export const RECEIVE_TRANSACTION_DATES = 'RECEIVE_TRANSACTION_DATES'

export const RECEIVE_REPO_MIN_TX_DATE = 'RECEIVE_REPO_MIN_TX_DATE'
export const SET_GETTING_REPO_MIN_TX_DATE = 'SET_GETTING_REPO_MIN_TX_DATE'

// appFrame
export const SET_SHRINK_HEADER = 'SET_SHRINK_HEADER'
export const SET_SHOW_NAV_PANEL = 'SET_SHOW_NAV_PANEL'
export const SET_PIN_NAV_PANEL = 'SET_PIN_NAV_PANEL'
export const SET_SHOW_FOOTER = 'SET_SHOW_FOOTER'
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
export const SET_NAV_TOGGLER_AS_NEEDED = 'SET_NAV_TOGGLER_AS_NEEDED'
export const SET_HEADER_TITLE = 'SET_HEADER_TITLE'
export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE'
export const SET_WINDOW_SCROLL_POS = 'SET_WINDOW_SCROLL_POS'
export const SET_STATUS_MESSAGE = 'SET_STATUS_MESSAGE'
export const SET_PATH = 'SET_PATH'
export const SET_CURRENT_NAV = 'SET_CURRENT_NAV'
export const ADD_DIALOG = 'ADD_DIALOG'
export const REMOVE_TOP_DIALOG = 'REMOVE_TOP_DIALOG'
export const SET_LICENSE_MESSAGE = 'SET_LICENSE_MESSAGE'

// licensing
export const RECEIVE_LICENSE_STATUS = 'RECEIVE_LICENSE_STATUS'

// stats
export const SET_STATS_PERIOD = 'SET_STATS_PERIOD'
export const SET_STATS_SOURCE_TYPE = 'SET_STATS_SOURCE_TYPE'

export const SET_GETTING_DOWNLOADS_BY_DAY = 'SET_GETTING_DOWNLOADS_BY_DAY'
export const RECEIVE_DOWNLOADS_BY_DAY = 'RECEIVE_DOWNLOADS_BY_DAY'
export const CLEAR_DOWNLOADS_BY_DAY = 'CLEAR_DOWNLOADS_BY_DAY'

export const SET_GETTING_LICENSES_USED = 'SET_GETTING_LICENSES_USED'
export const CLEAR_LICENSES_USED = 'CLEAR_LICENSES_USED'
export const RECEIVE_FIRST_LICENSES_USED = 'RECEIVE_FIRST_LICENSES_USED'
export const RECEIVE_NEXT_LICENSES_USED = 'RECEIVE_NEXT_LICENSES_USED'

export const SET_GETTING_PACKAGES_DOWNLOADED = 'SET_GETTING_PACKAGES_DOWNLOADED'
export const CLEAR_PACKAGES_DOWNLOADED = 'CLEAR_PACKAGES_DOWNLOADED'
export const RECEIVE_FIRST_PACKAGES_DOWNLOADED = 'RECEIVE_FIRST_PACKAGES_DOWNLOADED'
export const RECEIVE_NEXT_PACKAGES_DOWNLOADED = 'RECEIVE_NEXT_PACKAGES_DOWNLOADED'

// releases
export const CLEAR_RELEASES = 'CLEAR_RELEASES'
export const RECEIVE_FIRST_RELEASES = 'RECEIVE_FIRST_RELEASES'
export const RECEIVE_NEXT_RELEASES = 'RECEIVE_NEXT_RELEASES'
